import React, { useMemo } from 'react';
import styled from 'styled-components';
import SimpleTabs from '../../../SimpleTabs';
import ProfileView from './components/ProfileView';
import AnimatedTabs from './components/AnimatedTabs';
import AnimatedLogo from './components/AnimatedLogo';
import useAnimatedTabs from './hooks/useAnimatedComponents';
import useAccountNavValue from '../../hooks/useAccountNavValue';
import useChangeTabs from '../../hooks/useChangeTabs';

const TopNavTabs = styled(SimpleTabs)`
  position: sticky;
  top: -54px;
  z-index: 100;
  overflow: hidden;

  && .tab-flex-container {
    height: 96px;
  }
`;

type Props = {
  viewName?: string;
  userProfile: any;
};

const TopNav = (props: Props) => {
  const { viewName, userProfile } = props;

  const setTabIndex = useChangeTabs();
  const value = useAccountNavValue(viewName);
  useAnimatedTabs(useMemo(() => document.getElementsByClassName('to-be-animated'), []));

  return (
    <TopNavTabs onChange={setTabIndex as any} value={value}>
      <AnimatedLogo alt="solv logo" setTabIndex={setTabIndex} src="/images/logo/solv_dark.svg" />

      <AnimatedTabs animatedClassName="to-be-animated" label="Get Care" value={0} />

      <AnimatedTabs animatedClassName="to-be-animated" label="Insurance" value={1} />

      <AnimatedTabs animatedClassName="to-be-animated" label="Profile" value={2} />

      <ProfileView userProfile={userProfile} />
    </TopNavTabs>
  );
};

export default TopNav;
